export default __webpack_public_path__ + "media/images/building_images/placeholder_locations_1-49c7eeaed1ac601323cf61a62365e8ca.png";